import iotDeviceFeatureConfigService from '../../../../services/iotDevice/iotDeviceFeatureConfigService';
import deviceGlobalConfigService from '../../../../services/iotDevice/iotDeviceGlobalConfigService';
import iotDeviceSettingsService from '../../../../services/iotDevice/iotDeviceSettingsService';

const useVapeSessionEnabled = (iotDevice) => {
    const isVapeSession = iotDeviceSettingsService.isSettingAvailable(
        iotDevice,
        deviceGlobalConfigService.isGlobalSessionProfiling(iotDevice),
        iotDeviceFeatureConfigService.isSessionProfilingEnabled()
    );

    return isVapeSession;
};

export default useVapeSessionEnabled;
